import styled from 'styled-components';

import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

export const ExitButton = () => {
  const { t } = useTranslation('pages/pageInterwill', { keyPrefix: 'header' });

  return (
    <LeftContainer style={{ cursor: 'pointer' }}>
      <Icon name="arrow-left" size="s20" />
      <Title>{t('backBtnText')}</Title>
    </LeftContainer>
  );
};

const LeftContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  height: 72px !important;
  pointer-events: none;

  ${media.iwMobile} {
    height: 64px !important;
  }
`;

const Title = styled.span`
  font-weight: 700;
  color: ${COLORS.colorPrimary};
`;
